import { useEffect } from "react";
import { isDesktop } from "react-device-detect";

export const useAnimateOnScroll = () => {
  useEffect(() => {
    const elements = [
      ".postcontent > div",
      ".postcontent p",
      ".postcontent h2",
      ".postcontent h3",
      ".postcontent h4",
      ".postcontent li",
      ".postcontent h5",
      ".postcontent img",
      ".postcontent .accordion",
      ".postcontent .accordion-wrapper",
      ".postcontent .section-accordion",
      ".postcontent .video-container",
      ".postcontent blockquote",
      ".two-column",
      ".animateonscroll",
      ".slide-down",
      ".slide-up",
      ".slide-in-from-left",
    ];
    const scrollElements = document.querySelectorAll(elements.join(","));

    const options = {
      root: null,
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        entry.isIntersecting && entry.target.classList.add("visible");
      });
    }, options);

    scrollElements.forEach((el) => {
      observer.observe(el);
    });
  }, []);
};
